import { useIntl } from 'react-intl';
import { useTheme } from '@mui/material/styles';

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { SlideTransition } from './SlideTransition';

interface CommonProps {
  onAgree?: () => void;
  onDisagree: () => void;
  open: boolean;
}
interface Props extends CommonProps {
  title?: string;
  subTitle?: string;
  agreeLabel?: string;
  disagreeLabel?: string;
  dialogContent?: any;
}

const CustomDialog = (props: Props) => {
  const { title, subTitle, onAgree, onDisagree, agreeLabel, disagreeLabel, open, dialogContent } = props;
  const { formatMessage } = useIntl();
  const theme = useTheme();

  return (
    <Dialog
      TransitionComponent={SlideTransition}
      open={open}
      onClose={onDisagree}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      // disableBackdropClick
    >
      <DialogTitle sx={{ background: theme.palette.primary.main }} id="alert-dialog-title">
        <Typography variant="body1" sx={{ fontSize: "18px", fontWeight: "bold", textAlign: "center", color:'#fff' }}>{title ?? formatMessage({ id: "title" })}</Typography>
      </DialogTitle>

      <DialogContent>
        {dialogContent ?? (
          <>
            <DialogContentText id="alert-dialog-description" style={{ fontSize: "15px", textAlign: "center", color: theme.palette.text.primary, marginTop: "10px" }}>
              {subTitle ?? formatMessage({ id: "sub-title" })}
            </DialogContentText>
          </>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onDisagree} color="info" variant="outlined">
          {disagreeLabel ?? formatMessage({ id: "disagree" })}
        </Button>
        {onAgree &&
          <Button onClick={onAgree} color="info" variant="contained">
            {agreeLabel ?? formatMessage({ id: "agree" })}
          </Button>
        }
      </DialogActions>
    </Dialog>
  )
}

export { CustomDialog }
